<template>
  <article class="intro-with-info">
    <span class="intro-with-info__heading">
      <h2> {{ this.title }} </h2>

      <button
        class="intro-with-info__info info-button"
        v-on:click="toggleInfo"
      >
        <i class="fas fa-info-circle"></i>
      </button>
    </span>

    <p> {{ this.intro }} </p>

    <div class="overlay" :class="this.toggle ? 'toggled' : ''"></div>

    <div class="info-popup" :class="this.toggle ? 'toggled' : ''">
      <article class="info-popup__box">
        <span class="info-popup__box-heading">
          <h6 class="info-popup__box-title">
            {{ this.info.title }}
          </h6>

          <button
            class="info-popup__close-info info-button"
            v-on:click="toggleInfo"
          >
            <i class="fas fa-times"></i>
          </button>
        </span>

        <p> {{ this.info.text }} </p>
      </article>
    </div>
  </article>
</template>

<script>
export default {
  name: 'IntroWithInfo',
  props: [ 'title', 'intro', 'info' ],
  data () {
    return {
      toggle: false,
    }
  },
  methods: {
    toggleInfo () {
      this.toggle = !this.toggle
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-with-info {
  margin-bottom: 1rem;

  &__heading {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  &__info {
    @include breakpoints(medium) {
      margin-left: 2rem;
    }
  }
}

.overlay {
  display: none;
  position: fixed;
  height: 100vh;
  width: 100%;
  background-color: transparent;
  top: 0;
  left: 0;
}

.overlay.toggled {
  background-color: rgba(0, 0, 0, .25);
  display: block;
}

.info-popup {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  justify-content: center;
  align-items: center;
  z-index: 1;

  &.toggled {
    .info-popup {
      &__box {
        height: min-content;
        width: 90%;
        padding: 3rem;

        @include breakpoints(medium) {
          width: 50%;
        }
      }
    }
  }

  &__box {
    height: 0px;
    width: 0px;
    overflow: hidden;
    background-color: $light;
    border-radius: $borderRadius;
    position: relative;
    transition: all .3s ease-in-out;

    &-heading {
      display: flex;
      align-items: center;
    }

    &-title {
      margin-bottom: 1rem;
    }
  }

  &__close-info {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

.info-button {
  background-color: transparent;
  border: none;
  cursor: pointer;

  svg {
    font-size: 20px;
    color: $green;
    transition: color .3s ease-in-out;
  }

  &:hover {
    svg {
      color: $lightGreen;
    }
  }
}
</style>